import React, { Component } from 'react'
import * as moment from 'moment';
import 'moment/locale/pt-br';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Link } from 'react-router-dom'
import { deleteItem, fetchTransactions } from '../actions/transactionsActions'
import { connect } from 'react-redux'

@connect((store)=>{
  return {
    error: store.transactions.error,
    fetching: store.transactions.fetching,
    selectedCompany: store.user.selectedCompany,
    currentSettings: store.user.currentSettings,
  } 
})

class Table extends Component {

  state = {
    "Crédito": 'fas fa-plus iconSmall iconGreen',
    "Débito": 'fas fa-minus iconSmall iconRed'
  }

  handleDelete = (empresa,id) => {
    this.props.dispatch(deleteItem(empresa, id))
    this.props.dispatch(fetchTransactions(this.props.selectedCompany, this.props.currentSettings))
  }

  render() {

    return (
      <div className="table-container">
          <ReactTable
          data={this.props.transactions}
          columns={[
            {
              Header: "Ações",
              Cell: row => (<div>
              <center>
              <Link to={`/transactions/edit/${row.original.id}`}><i className="far fa-edit icons"/></Link>&nbsp;
              <Link to={`/transactions/duplicate/${row.original.id}`}><i className="far fa-copy icons "/></Link>&nbsp;
              <span onClick={() => this.handleDelete(row.original.id, this.props.selectedCompany) }><i className="far fa-trash-alt icons"/></span>
              
              </center>
              </div>),
              width: 80
            },
            {
              Header: "Data",
              id: "data",
              accessor: d => moment(d.data).format('L'),
              sortMethod: (a, b) => {
                let a2 = new Date(a.split(/\//).reverse().join('/'));
                let b2 = new Date(b.split(/\//).reverse().join('/'));
                if (moment(a2).isBefore(b2))    return -1;
                else if(moment(a2).isAfter(b2)) return  1;
                else                      return  0;
                
              },
              Cell: row => (<div><center>{row.value}</center></div>)
            },
            {
              Header: "Descrição",
              accessor: "descricao",
              Cell: row => (<div>{row.value}</div>),
              width: 300
            },
            {
              Header: "Conta",
              accessor: "conta",
              Cell: row => (<div><center>{row.value}</center></div>),
            },        
            {
              Header: "Valor",
              id: "valor",
              accessor: d => "R$" + (d.valor ? d.valor.toLocaleString('pt-BR') : 0),
              sortMethod: (a, b) => {
                let a2 = parseInt(a.replace('R$','').replace('.','').replace(',','.'), 8)
                let b2 = parseInt(b.replace('R$','').replace('.','').replace(',','.'), 8)
                return a2-b2
              },
              Cell: row => (<div><center>{row.original.comprovante ? <a target='_blank' href={row.original.comprovante}>
              <i style={{color:'#a9a9a9'}} className='far fa-file-pdf'/></a>:null} {row.value}</center></div>)
            },
            {
              Header: "Processado",
              id: "processad",
              accessor: d => {if(d.processado){return 'Sim'}else{return 'Não'}},
              Cell: row => (<div><center>{row.value}</center></div>)
            },
            {
              Header: "Tipo",
              id: "debito",
              accessor: d => {if(d.debito){return 'Débito'}else{return 'Crédito'}},
              Cell: row => (
              <div><center>
              &nbsp;&nbsp;{row.value}</center></div>)
            }
          ]}
          defaultSorted={[
            {
              id: "data",
              desc: true
            }
          ]}
          defaultPageSize={25}
          className="-striped -highlight"
        />
      </div>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/Table.js